import * as React from 'react';
import { UnitPrice, BestPrice } from '@grandvisionhq/common';
import { ProductDiscountBadge } from '@grandvisionhq/lib-visuals';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { useProductDetailSlots } from '../../../../slots/context.js';
import { FromPriceDisclaimersContainer } from './components/FromPriceDisclaimers/FromPriceDisclaimersContainer.js';
import { ProductDetailPrice } from './components/ProductDetailPrice/ProductDetailPrice.js';
import { PriceDisclaimerContainer } from './components/PriceDisclaimer/PriceDisclaimerContainer.js';

const PriceSection = ({ originalPrice , orignalPriceCurrencyCode , discountedPrice , discountBadge , discountDescription , pricePerUnit , bestPrice , shouldDisplayFromPrice , fromPricePrefix ,  })=>{
    const { getLabel  } = useIntl();
    const { isBestPriceEnabled , isPricePerUnitEnabled , featureConfigs: { unitPriceFixedDecimalsConfig  } = {} ,  } = useFeatureToggles();
    const { Slots  } = useProductDetailSlots();
    const discountIsZero = discountedPrice === originalPrice;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "price-section",
        role: "group",
        "aria-label": getLabel('products.screenreader.priceInformation'),
        "data-t": "price-section"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "price-section__price-row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "price-section__price-wrapper"
    }, /*#__PURE__*/ React.createElement(ProductDetailPrice, {
        isCentAmount: false,
        originalPrice: originalPrice,
        discountedPrice: discountedPrice,
        currency: orignalPriceCurrencyCode,
        prefix: fromPricePrefix
    })), isPricePerUnitEnabled && pricePerUnit && /*#__PURE__*/ React.createElement(UnitPrice, {
        amount: pricePerUnit,
        currencyCode: orignalPriceCurrencyCode,
        fixedDecimals: unitPriceFixedDecimalsConfig === null || unitPriceFixedDecimalsConfig === void 0 ? void 0 : unitPriceFixedDecimalsConfig.pdp
    })), !!discountBadge && !discountIsZero && /*#__PURE__*/ React.createElement(ProductDiscountBadge, {
        className: "price-section__discount",
        discount: discountBadge,
        label: discountDescription,
        isWide: true
    }), shouldDisplayFromPrice && /*#__PURE__*/ React.createElement(FromPriceDisclaimersContainer, null), /*#__PURE__*/ React.createElement(PriceDisclaimerContainer, null), /*#__PURE__*/ React.createElement(BestPrice, {
        isFeatureEnabled: isBestPriceEnabled,
        bestPriceAmount: bestPrice,
        isCentAmount: false,
        currencyCode: orignalPriceCurrencyCode,
        discountedPrice: discountedPrice,
        originalPrice: originalPrice,
        className: "price-section__best-price"
    })), Slots.AfterPrice && /*#__PURE__*/ React.createElement(Slots.AfterPrice, null));
};

export { PriceSection };
//# sourceMappingURL=PriceSection.js.map
